// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"5e983704","488":"ecd5fc5f","796":"aeac71a4"}[chunkId] + ".chunk.js";
};